import type { FirebaseClientConfig } from "@storyworm/firebase";

/**
 * Firebase Web SDK config for the SSUP (partner validation) project.
 *
 * This is the *public* client config for the standalone `storyworm-ssup`
 * Firebase project — deliberately separate from the consumer app's project so
 * licensed-IP / partner data and children's data never share a project
 * boundary. These values are safe to ship in the client bundle (Firebase
 * security is enforced by Auth + security rules, not by hiding this config).
 *
 * Kept as literals for now to keep the scaffold bootable without extra .env
 * setup; promote to `import.meta.env.VITE_*` when per-environment configs are
 * needed.
 */

/**
 * The Google OAuth redirect goes through `https://<authDomain>/__/auth/handler`,
 * so `authDomain` must be a domain whose handler is an *authorized redirect URI*
 * on the project's OAuth client:
 *  - dev (localhost): the default `*.firebaseapp.com` handler is auto-registered
 *    by Firebase and works from localhost — no extra setup, so testing works.
 *  - prod: the custom `portal.storyworm.ai` handler (hides the firebaseapp.com
 *    branding on the consent screen). Requires that domain to be served by
 *    Firebase Hosting AND added as an authorized redirect URI on the OAuth
 *    client; otherwise Google returns Error 400: redirect_uri_mismatch.
 */
const AUTH_DOMAIN = import.meta.env.PROD
  ? "portal.storyworm.ai"
  : "storyworm-ssup.firebaseapp.com";

export const SSUP_FIREBASE_CONFIG: FirebaseClientConfig = {
  apiKey: "AIzaSyD0KjI2nTKxwgnXfQ2KNZSceEozh31IAxw",
  authDomain: AUTH_DOMAIN,
  projectId: "storyworm-ssup",
  storageBucket: "storyworm-ssup.firebasestorage.app",
  messagingSenderId: "738084636283",
  appId: "1:738084636283:web:e813bb45c2ec1e65ad84de",
  measurementId: "G-Z2H8Z64BM8",
};
